export const DATE_FORMAT = 'dd/MM/yyyy';
export const MIN_DATE = new Date('2018-01-01');
export const MAX_DATE = new Date('2035-12-31');
